/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { datadogRum } from '@datadog/browser-rum';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() { return document.getElementsByTagName('base')[0].href; }

const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];

if (environment.production) { enableProdMode(); }

// Get the JSON web token from local storage
const jwt = localStorage.getItem('jwt') === null 
	? null 
	: (localStorage.getItem('jwt') && localStorage.getItem('jwt')?.substr(0, 1) !== '"')
		? localStorage.getItem('jwt')
		: JSON.parse(localStorage.getItem('jwt')!);

// If we have a JSON web token, send AJAX request to get user information
// before bootstrapping Angular
if (jwt) {
	if (globalThis.navigator.onLine) {
		const xhr = new XMLHttpRequest();
		xhr.open('POST', getBaseUrl() + 'api/Account/GetUserInfo');
		xhr.setRequestHeader('Content-Type', 'application/json');
		xhr.setRequestHeader('Authorization', `Bearer ${jwt}`);
		xhr.onload = function () {
			if (xhr.status === 200) {
				const model = JSON.parse(xhr.response);
				if (model.user === null) {
					// The server no longer accepts this token (a revoked, expired or unknown session reads
					// as signed out on an anonymous endpoint), so drop it rather than writing it back.
					// Keeping it booted the app holding an unexpired token with no user or security.
					localStorage.removeItem('jwt');
					localStorage.removeItem('user');
					localStorage.removeItem('dynamicSecurity');
				} else {
					localStorage.setItem('dynamicSecurity', JSON.stringify(model.security));
					localStorage.setItem('user', JSON.stringify(model.user));
					localStorage.setItem('jwt', JSON.stringify(jwt));
				}
				// Flag so the dashboard doesn't immediately re-fetch user info on initial load
				sessionStorage.setItem('userInfoFetched', 'true');
			}
			bootstrapAngular();
			bootstrapDataDogRum();
		};
		xhr.send();
	} else { bootstrapAngular(); }
} else {
	// If we don't have a token, just bootstrap Angular
	localStorage.removeItem('user');
	bootstrapAngular();
}

function bootstrapAngular() {
	// The service worker is registered by ServiceWorkerRegistrationService (S2N-3226)
	platformBrowser().bootstrapModule(AppModule).catch(err => console.log(err));
}

function bootstrapDataDogRum() {
    if (environment.production) {
        datadogRum.init({
            applicationId: 'f959aa3c-a7a9-43a1-8a68-60b325ee232e'
            , clientToken: 'pub7c911faf7993ab48b8e3603c61aed9c3'
            , site: 'us5.datadoghq.com'
			, service: 's2'
			, allowedTracingUrls: ["https://app.schedule2.it"]
			, env: 'production'
            // Specify a version number to identify the deployed version of your application in Datadog
            // This will be set within a task in your CI pipeline.
            , version: '748ec8f'
			, sessionSampleRate: 100
			, sessionReplaySampleRate: 100
			, trackUserInteractions: true
			, trackResources: true
			, trackLongTasks: true
			, defaultPrivacyLevel: 'allow'
        });
		setDatadogUser();
	}
}

function setDatadogUser() {
	let user = JSON.parse(localStorage.getItem('user')!)
	if (user != null) {
		datadogRum.setUser({
			id: user?.id
			, email: user?.email
			, name: `${user?.fullName}` 
		});
	}
}
